module.exports = __webpack_public_path__ + "img/menu_black_24dp.9d9bd20c.svg";